import React from 'react'
import { Doughnut } from 'react-chartjs-2'
// import ChartDataLabels from 'chartjs-plugin-datalabels';


const DoughnutChart = (props) => {

  let diff = (num1, num2) => {
    return num1 - num2
  }

  const { totalUsage, totalProduction, utility } = props

  let usage = Math.round(diff(totalUsage, totalProduction) / totalUsage * 100)

  let production = Math.round(totalProduction / totalUsage * 100)

  if (Math.round(diff(totalUsage, totalProduction) / totalUsage * 100) < 0) {
    usage = 0
  }




  return (
    <>
      <Doughnut
        data={{
          
          labels: ['ION Solar', utility],
          datasets: [
            {
              label: 'Offset',
              datalabels: {
               display: false
              },
              data: [

                production,
                usage
              ],
              backgroundColor: [
                'rgba(18, 42, 162, 0.98)',
                'rgba(196, 196, 196, 0.927)',

              ]
            }
          ]
        }}
        options={{
          
          responsive: true,
          // cutoutPercentage: 80,
          title: {
            display: false,
            text: 'Usage Offset',
            fontSize: 0,
            fontColor: '#000'
          },
          legend: {
            display: false,
            position: 'bottom',
            labels: { fontColor: '#000' }
          }
        }} />
    </>
  )

}

export default DoughnutChart